import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { RepeatableInfoDialogView } from '../../../interfaces/input.interface';

@Component({
    selector: 'app-repeatable-product-info-dialog',
    standalone: false,
    templateUrl: './product-info-dialog.component.html',
    styleUrls: ['./product-info-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepeatableProductInfoDialogComponent {
    @Input() public visible = false;
    @Input() public view: RepeatableInfoDialogView | null = null;

    @Output() public visibleChange = new EventEmitter<boolean>();

    public get headerText(): string {
        return this.view?.header ?? 'Información';
    }

    public close(): void {
        this.visibleChange.emit(false);
    }
}
